import { useContext } from 'react';
import { AvatarEditorContext } from "../components/utils/AvatarEditorProvider";

const useEditAvatar = () => {
  return useContext(AvatarEditorContext);
}

export default useEditAvatar;
